<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <label class="custom-control-label me-1"><span [hidden]="!includeLabel">{{getLabelName()}}</span></label>
    <div class="custom-switch custom-control-inline mb-1 mb-xl-0" (click)="changeValue($event)">
        <input #field type="checkbox" class="form-check-input" [id]="(id === null ? name : id)"
            [name]="name" [checked]="value" [disabled]="readOnly">
    </div>
</ng-template>
<ng-template #showSpan>
    <div [hidden]="!includeLabel">
        <label for="{{name}}">{{getLabelName()}}</label>
    </div>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{detailModeText()}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>
